module.exports = {
  // 公用部分
  new: "新建",
  query: "查询",
  reset: "重置",
  save: "保存",
  exit: "退出",
  clean: "清除",
  choose: "选择",
  del: "删除",
  back: "返回",
  saveAndBack: "保存并返回",
  remove: "移除",
  add: "添加",
  saveAndNew: "保存并新建",
  cancel: "取消",
  confirm: "确定",
  enter: "进入",
  signin: "登陆",
  refresh: "刷新",
  verify_link: "验证链接",
  synchronize_domain: "同步域(租户)组织架构到微信企业号",
  synchronize_organizational: "同步微信企业号组织架构到域(租户)",
  sync_dinging2org: "同步域(租户)组织架构到钉钉企业号",
  sync_dingding2domain: "同步钉钉企业号组织架构到域(租户)",
  edit: "编辑",
  clearConfig: "清除缓存数据",
  clearConfigId: "清除冗余数据",
  synchronization: "同步数据表单",
  indexOptimization: "索引优化",
  import: "导入",
  export: "导出",
  exportAll:'导出全部',
  admin: "管理员",
  name: "名称",
  loginno: "账号",
  email: "电子邮箱",
  tel: "手机",
  username: "用户名称",
  password: "密码",
  confirm_pwd: "确认密码",
  public: "公开",
  // login
  character: "字符",
  error: "错误",
  login: "登录",
  // home
  home: "主页",
  loginout: "注销",
  closeHelp: "帮助",
  platform: "管理员中心",
  enterprise_domain: "域(租户)管理",
  superuser: "特权用户管理",
  systemCon: "系统管理",
  systemMoni: "系统监控",
  debugmode: "调试模式",
  // main
  location: "当前位置：主页",
  enterprise_list: "域(租户)列表",
  enterprise_name: "域(租户)名称",
  active: "激活",
  inactive: "不激活",
  activated: '已激活',
  inactivated: "未激活",
  // domain
  detail: "详情",
  baseInfo: "基本信息",
  department: "部门",
  user: "用户",
  appconfig: "软件",
  weixinConfig: "微信配置",
  dingdingConfig: "钉钉配置",
  calendar: "工作日历",
  fieldextend: "字段扩展",
  userlog: "操作日志",
  flowstaterts: "流程监控",
  emailconfig: "邮件设置",
  timedtask: "定时任务",
  // baseinfo
  base_info_setting: "基本信息设置",
  enterprise_info: "域(租户)信息",
  skinType: "选择皮肤",
  smsMemberCode: "天翎短信平台帐号",
  smsMemberPwd: "天翎短信平台密码",
  testSMS: "测试短信发送",
  noAccount: "还没有帐号?",
  wantToChangePwd: "修改密码?请登录天翎短信平台!",
  systemName: "系统名称",
  description: "描述",
  status: "是否有效",
  setSuperior: "设置上级",
  superior: "上级",
  subordinate: "下级",
  // department
  department_import: '部门导入',
  dept_list: "部门列表",
  dept_name: "部门名称",
  superior_dept: "上级部门",
  level: "层级",
  dept_info: "部门信息",
  orderByNo: "排序号",
  select_dept: "选择部门",
  code: "代码",
  valid: "有效性",
  owned_user: "所属用户",
  // user
  user_list: "用户列表",
  user_import: "用户导入",
  user_export: "用户导出",
  user_name: "用户姓名",
  user_no: "用户账号",
  superior_name: "上级用户",
  select_role: "请选择角色",
  select_software: "请选择软件",
  dimission_status: "状态",
  resign: "失效",
  on_job: "正常",
  // user_detail
  user_info: "用户信息",
  settingInfo: "设置信息",
  moreInfo: '更多信息',
  proxyUser: "代理人用户",
  startProxyTime: "代理开始日期",
  endProxyTime: "代理结束日期",
  domainUser: "部门管理员",
  address_book: "通讯录中显示个人信息",
  liaisonOfficer: "部门接口人",
  lockFlag: "登录异常锁定",
  useIM: "使用即时通讯",
  dimission: "是否离职",
  add_dept: "添加部门",
  setDefault: "设置为默认",
  datetime: "选择日期时间",
  setRole: "设置角色",
  kmSetting: "KM管理",
  staff: "员工",
  dept_know_manager: "部门知识管理员",
  committee_know_manager: "专委会知识管理员",
  enterprise_know_manager: "企业知识管理员",
  // appconfig
  basic_software_config: "基础软件配置",
  pmEnable: "启用任务管理软件",
  qmEnable: "启用调查问卷软件",
  amEnable: "启用微考勤软件",
  cmEnable: "启用联系人管理软件",
  pcmEnable: "流程中心",
  kmEnable: "启用知识文档管理软件",
  kmTeamEnable: "团队",
  kmRealmEnable: "知识专题",
  km_role: "KM角色管理",
  custom_software: "自定义软件配置",
  software_name: "软件名称",
  mode: "模式",
  regular_mode: "常规模式",
  platform_mode: "平台模式",
  operating: "操作",
  export_operation: "导出操作",
  fettle: "状态",
  add_role: "角色添加",
  bpm_Mode_Conf: "BPM平台模式配置",
  role_menu: "角色&菜单",
  role_user: "角色&用户",
  // appconfig_add
  appconfig_add: "添加软件",
  // superuser
  super_user_list: "特权用户列表",
  user_type: "用户类型",
  superAdmin: "超级管理员",
  secret: "安全保密员",
  develop: "开发者",
  examine: "安全审查员",
  system_admin: "系统管理员",
  // superuser_detail
  superuser_detail: "特权用户详情",
  add_field: "添加字段",
  management_scope: "管理范围",
  belong_domains: "所属域",
  belong_dept: "所属部门",
  key: "密钥",
  generate: "生成",
  // 系统监控
  system_monitoring: "系统监控",
  server_monitoring: "服务器监控",
  druid_Monitor: "对数据源连接情况、sql执行效率、sql防火墙、web并发、session等多维度的实时监控",
  jamon: "监控宏语言、系统类方法及Sql的执行效率",
  swagger2: "Swagger接口文档",
  web_services: "web-services调用和执行情况",
  onlineUsers: "监控服务器当前在线用户会话(Session)情况",
  // swagger
  domain: "域(租户)",
  front_user: "前台用户",
  // onlineuser
  online_user: "在线用户",
  online_num: "当前在线用户数：",
  login_time: "登录时间",
  off_line: "强制下线",
  // jamen
  is_open_monitoring: "是否开启监控：",
  // manager
manager_list: "管理员列表",
  // user_select
  add_admin_list: "添加管理员列表",
  // weixin
  activate_weChat: "启用微信企业号",
  no_wechat_service: "不开启微信服务",
  enterprise_wechat: "手工配置模式(企业微信)",
  startup: "启动",
  weixincorpID: "企业微信CorpID",
  weixinCorpSecret: "通讯录Secret",
  serverHost: "外网访问系统地址",
  verification_link: "验证链接",
  weixinQrCodeAgentId: "微信扫码AgentId",
  weixinQrCodeSecret: "微信扫码Secret",
  weixinQrCodeCallbackUrl: "微信扫码CallbackUrl",
  enabled_software: "已启用的软件列表",
  weixinAgentId: "*微信应用AgentId",
  weixinSecret: "*微信应用Secret",
  weChatURL: "微信菜单跳转链接",
  jumplink: "生成跳转链接",
  // weixinUrl
  weixinUrl: '微信端配置',
  menuName: '菜单名称',
  jump_link: '跳转链接',
  // rolelist
  rolelist: "角色列表",
  rolename: "角色名称",
  // dingding
  activate_dingding: "启用钉钉企业号",
  no_dingding_service: "不开启钉钉服务",
  enterprise_dingding: "手工配置模式(钉钉)",
  dingdingCorpID: "企业钉钉CorpID",
  dingdingServerHost: "外网访问系统地址",
  address_book_application: "通讯录应用",
  dingdingAgentId: "通讯录AgentId",
  dingdingKey: "通讯录AppKey",
  dingdingSecret: "通讯录AppSecret",
  scancode: "扫码设置",
  dingdingQrCodeAppId: "钉钉扫码appid",
  dingdingQrCodeAppSecret: "钉钉扫码appSecret",
  dingdingQrCodeCallbackUrl: "钉钉扫码重定向地址",
  dingdingAppAgentId: "*钉钉应用AgentId",
  dingdingAppKey: "*钉钉应用AppKey",
  dingdingAppSecret: "*钉钉应用Secret",
  dingdingURL: "钉钉菜单跳转链接",
  // calendar
  calendarList: "工作日历列表",
  calendarName: "日历名称",
  // calendar_detail
  new_calendar: "新建工作日历",
  edit_calendar: "修改工作日历",
  from_calendar: "从日历",
  copy_calendar: "复制至新日历名称",
  // userlog
  log: "操作日志",
  userlog_record: "是否记录用户操作日志：",
  operator: "操作人",
  select_date: "选择日期",
  type: "类型",
  date: "日期",
  // flowstatert
  flowName: "流程名称",
  stateLabel: "当前节点",
  initiator: "发起人",
  firstProcessTime: "流程开始时间",
  lastAuditor: "最后处理人",
  lastProcessTime: "最后处理时间",
  summary: "摘要",
  flowboard: "流程仪表盘",
  // flowstaterts
  today: "今天",
  week: "本周",
  month: "本月",
  year: "年",
  show_user: "显示所有用户",
  time_consuming: "流程节点耗时-TOP10",
  startnodename: "开始节点名称",
  endnodename: "结束节点名称",
  auditor: "处理人",
  amount: "耗时(H)",
  nodata: "暂无数据",
  // flowstaterts_detail
  flowstaterts_detail: "流程详情",
  flow_intervention: "流程干预",
  add_intervention_node: "添加干预节点",
  node_approver: "节点审批人",
  intervention_node: "干预节点",
  flow_node: "后台干预至流程节点",
  flow_node_after_intervention: "干预后流程节点处理人",
  // emailconfig
  mail_setting: "系统邮件发送设置",
  sendHost: "发送主机",
  sendAddress: "发出地址",
  sendAccount: "发送账号",
  sendPassword: "发送密码",
  ccAddress: "抄送地址",
  base_setting: "基本设置",
  isUseClient: "是否使用客户端",
  functionDomain: "邮件功能域",
  file_mapping: "邮件客户端与服务器的文件映射",
  trash: "垃圾箱",
  sender: "发送箱",
  draft: "草稿",
  removed: "已删除",
  fetchssl: "是否需要证书",
  fetchServer_config: "收件服务器配置",
  fetchServer: "收取邮件服务器",
  fetchServerPort: "收取邮件服务器端口",
  fetchProtocol: "收取邮件协议",
  send_serve_config: "发送服务器配置",
  smtpServer: "发送邮件服务器",
  smtpServerPort: "发送邮件服务器端口",
  smtpAuthenticated: "是否可带附件",
  smtpssl: "是否需要证书",
  // timedtask
  start: "开始",
  creator: "创建人",
  startup_type: "启动类型",
  runtime: "运行时间",
  runnum: "运行次数",
  period: "周期",
  manual: "手动",
  auto: "自动",
  banned: "禁止",
  state: "状态",
  stoped: "停止",
  run: "运行",
  do_not_repeat: "不重复",
  immediately: "立刻",
  minute: "分钟",
  hour: "小时",
  day: "每日",
  weeks: "每周",
  months: "每月",
  running_on: "运行在",
  sunday: "星期日",
  monday: "星期一",
  tuesday: "星期二",
  wednesday: "星期三",
  thursday: "星期四",
  friday: "星期五",
  saturday: "星期六",

  // fieldextend
  string: "字符串",
  clob: "大字段",
  radio: "单选框",
  checkbox: "复选框",
  address: "地址",
  select: "下拉框",
  upload: '图片上传',
  owned_field: "所属字段",
  show_label: "显示标签",
  tableUser: "用户模块",
  tableDept: "部门模块",
  tableDomain: "域模块",
  show_list: "是否在列表中显示",
  show: "显示",
  not_show: "不显示",
  // fieldextend_detail
  owned_module: "所属模块",
  yes: "是",
  no: "否",
  order: "排序",
  isRequire: "是否必填",
  isRead: '是否只读',
  isQuery: '是否查询',
  options: "自定义选项(请用;隔开)",
  // systemcon
  authConfig: "身份验证设置",
  LDAP: "LDAP设置",
  policy: "用户密码策略",
  manage: "缓存与数据管理",
  hxImConfig: "环信配置",
  SystemFile: '系统字段',
  // config
  userstohx: "同步用户",
  hx_manage: "HX管理后台",
  // authconfig
  multiuserlogin: "是否允许多点登录",
  haveImg: "登录背景图片设置",
  uploadBgImg: "上传",
  cleanBgImg: "清除",
  authType: "身份验证模式：",
  interface: "界面登录",
  sso: "单点登录",
  ssl_pkcs12: "通过PKCS12客户端证书登录",
  smsAuthenticate: "是否开启手机短信验证：(注意:开启手机短信验证需要重启服务器后才生效)",
  smsAffectMode: "作用类型：",
  all: "所有",
  match: "匹配ip范围",
  exclude: "排除ip范围",
  ip_range: "作用ip范围：",
  smsTimeout: "超时（单位“秒”）：",
  smsContent: "短信内容(“$”代表验证码)：",
  checkldap: "单点登录验证方式：",
  ssoRedirect: "首页重定向地址：",
  ssoLogoutRedirect: "注销重定向地址：",
  localServerName: "cas服务器名称：",
  casLoginUrl: "cas服务器登录url：",
  casUrlPrefix: "cas服务器url前缀：",
  adDomainController: "AD域所在服务器IP：",
  adDefaultDomain: "AD域名：",
  adadminloginno: "AD域所在服务器管理员账号：",
  adadminloginnopw: "AD域所在服务器管理员密码：",
  adlogindomain: "AD域登录域(租户)：",
  adjespausernmae: "JESPA用户名：",
  adjespapassword: "JESPA密码：",
  user_synchronization: "用户同步设置",
  ssoDefaultEmail: "默认邮箱地址：",
  ssoDefaultPassword: "默认密码：",
  setting_after_auth: "认证后用户信息保存设置",
  ssoSaveType: "保存方式：",
  none: "无",
  ssoDataEncryption: "数据加密方式：",
  ssoKeyLoginAccount: "用户登录账号键名称：",
  ssoKeyDomain: "域(租户)键名称：",
  ssoKeyEmail: "用户邮箱键名称：",
  // LDAP
  ldapurl: "LDAP服务器地址：",
  dirStructure: "用户DN：",
  pooled: "是否池化：",
  manager_account: "管理账户：",
  managerPassword: "管理账户密码：",
  ldap_mapping: "LDAP用户字段映射设置",
  userClass: "用户类:",
  id_: "用户ID：",
  name_: "用户名称：",
  loginno_: "用户登录账号：",
  loginpwd_: "用户登录密码：",
  email_: "邮箱地址：",
  telephone_: "电话号码：",
  ldap_dept: "部门字段映射设置",
  deptClass: "部门类: ",
  enterDept: "顶级部门:",
  // policy
  min_length: "最小密码长度：",
  max_length_tip: "（设置值不能超过系统密码最大长度值，此项不填默认为1）",
  failLoginTimes: "最多错误输入密码错误次数：",
  nocheck: "（不填则不做此项检查）",
  legal: "密码同时由英文大小写特殊字符和数字构成：",
  pwd_change: "密码修改通知策略",
  noticeAuthor: "密码永不过期：",
  maxAge: "密码过期时间（天）：",
  noticeTime: "几天后通知修改密码（天）：",
  noticeMethodArr: "密码修改通知方式：",
  sms: "短信",
  msg_center: "消息中心",
  noticeContent: "通知内容：",
  // manage
  clean_cache: "此操作会清除服务器上所有数据的缓存",
  select_soft: "请选择软件:",
  cache_manage: "缓存管理",
  data_manage: "数据管理",
  clean_redundant: "此操作会清除业务库的冗余数据",
  // icon_select
  select_icon: "选择图标",
  picture_icon: "图片图标",
  customIcon: "自定义图标",
  upload_icon: "上传图标",
  batch_editing: "批量编辑",
  cancel_edit: "取消编辑",
  batch_delete: "批量删除",
  select_all: "全选",
  // roleBatchUser
  select_user: "选择用户",
  please_select_dept: "请选择部门",
  // kmrolemanager
  select_roles: "角色选择",
  // fileUpload
  annex: '附件：',
  importing: '正在导入中',
  download_template: '点击下载模板',
  upload_txt: '将文件拖到此处，或',
  upload_click: '点击上传',
  upload_img: '图片上传',
  upload_bgImg: '登录背景图片上传',
  upload_custom_icon: '自定义图标上传',
  excel_user_import: 'Excel用户导入',
  // add_deportment
  select_superior_dept: '选择上级部门',
  // 公用提示
  msg_tip: "提示",
  placeholder_select: "请选择",
  placeholder_enter_content: "请输入内容",
  msg_send_success : "发送成功",
  msg_send_fail: "发送失败",
  msg_name: '请输入用户名称',
  msg_account: '请输入账号',
  msg_pwd: '请输入密码',
  msg_email: '请输入邮箱',
  msg_length: '长度在 1 到 15 个字符',
  msg_eamilFormat: '邮箱格式不正确',
  msg_require_tel: "请输入手机号码",
  msg_incorrect_phone: "手机号码格式不正确",
  msg_require_name: "用户名称为必填项",
  msg_special_char: "用户名称不能输入特殊字符",
  msg_require_loginno: "账号为必填项",
  msg_orderno_negative: "排序号不能为负数",
  msg_require_calendar: "日历为必填项",
  msg_tel_incorrectly: "手机号输入有误",
  msg_email_incorrectly: "电子信箱输入有误",
  msg_require_dept: "用户必须选择部门",
  msg_select_role: "用户必须选择软件角色",
  msg_startProxyTime: "请填写代理开始日期",
  msg_endProxyTime: "请填写代理结束日期",
  msg_require_password: "用户密码为必填项",
  msg_default_dept: "默认部门为必填项",
  msg_save_success: "保存成功!",
  msg_select_software: "请选择一个软件",
  msg_remove_success: "移除成功",
  msg_del_success: "删除成功!",
  msg_select_superuser: "请先选择一个特权用户",
  msg_select_domain: "请先选择域(租户)",
  msg_select_user: "请先选择用户",
  msg_offline: "强制下线成功",
  msg_add_success: "添加成功!",
  msg_timeout: "连接超时!",
  msg_verified_success: "验证成功",
  msg_verified_failed: "验证失败",
  msg_require_agentId: "请填写微信应用AgentId",
  msg_require_secret: "请填写微信应用Secret",
  msg_cancel: "取消输入",
  msg_require_dingdingAgentId: "请填写钉钉应用AgentId",
  msg_require_dingdingAppKey: "请填写钉钉应用Secret",
  msg_require_dingdingAppSecret: "请填写钉钉应用Secret",
  msg_del_failed: "删除失败",
  msg_cancel_del: "已取消删除",
  msg_del_calendar: "请选择一个日历进行删除",
  msg_calendar_exist: "该日历名称已存在!",
  msg_require_calendarName: "请填写新日历名称!",
  msg_require_calendarId:'请填写从日历',
  msg_new_success: "新建成功!",
  msg_select_data: "请至少选择一条数据",
  msg_select_flowdata: "请至少选择一条流程进行删除",
  km_tip: "(选择需要设置KM角色的用户，此次设置将会清空用户原来的角色设置，未选择的用户将不受影响)",
  msg_select_dept: '请选择一个部门',
  msg_upload_file: '请上传文件!',
  msg_err_upload: '上传失败',
  msg_upload_success: '导入成功!',
  msg_select_img: '请先选择一个图标!',
  msg_filter: '输入关键字进行过滤',
  msg_select_admin: '请先选择一个管理员',
};
